import React from 'react';
import { Section } from './ui/Section';
import { Scale, Utensils, ShoppingCart } from 'lucide-react';
import { motion } from 'framer-motion';
export function Sistema3C() {
  return <Section className="bg-sage-light/50 rounded-3xl my-12" data-id="element-108">
      <div className="text-center mb-10" data-id="element-109">
        <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-110">
          El mecanismo: Sistema 3C
        </h2>
        <p className="text-xl text-sage-dark font-medium" data-id="element-111">
          (simple, repetible, real)
        </p>
      </div>

      <div className="space-y-6" data-id="element-112">
        {/* C1 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-113">
          <div className="flex items-center gap-3 mb-3" data-id="element-114">
            <div className="p-2 bg-cream rounded-lg" data-id="element-115">
              <Scale className="w-6 h-6 text-sage-dark" data-id="element-116" />
            </div>
            <h3 className="text-xl font-bold" data-id="element-117">C1) Carbo controlado</h3>
          </div>
          <p className="text-brown-body pl-14" data-id="element-118">
            Porciones visuales, sin balanza ni calculadora.
          </p>
        </motion.div>

        {/* C2 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-119">
          <div className="flex items-center gap-3 mb-3" data-id="element-120">
            <div className="p-2 bg-cream rounded-lg" data-id="element-121">
              <Utensils className="w-6 h-6 text-sage-dark" data-id="element-122" />
            </div>
            <h3 className="text-xl font-bold" data-id="element-123">C2) Combo</h3>
          </div>
          <p className="text-brown-body pl-14 mb-2" data-id="element-124">
            Carbo + proteína + fibra/verduras (y un poco de grasa).
          </p>
          <p className="text-brown-body/80 text-sm pl-14 italic" data-id="element-125">
            Porque una comida que no sostiene, te empuja a picotear después.
          </p>
        </motion.div>

        {/* C3 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-white p-6 rounded-2xl shadow-md border-2 border-sage/20 relative overflow-hidden" data-id="element-126">
          <div className="absolute top-0 right-0 w-16 h-16 bg-sage/10 rounded-bl-full -mr-8 -mt-8" data-id="element-127"></div>

          <div className="flex items-center gap-3 mb-3" data-id="element-128">
            <div className="p-2 bg-sage text-white rounded-lg" data-id="element-129">
              <ShoppingCart className="w-6 h-6" data-id="element-130" />
            </div>
            <h3 className="text-xl font-bold text-sage-dark" data-id="element-131">C3) Cierre</h3>
          </div>
          <p className="text-brown-body pl-14 mb-3" data-id="element-132">
            Lista por pasillos + mini-prep + plan de emergencia.
          </p>
          <p className="text-amber font-medium pl-14" data-id="element-133">
            Acá es donde la mayoría falla. Acá es donde este PDF te sostiene.
          </p>
        </motion.div>
      </div>
    </Section>;
}